// Redesign 2026 – chování hlavičky: hamburger, dropdowny (hover + klik + klávesnice), sticky výška.
// Markup: includes/template-parts/redesign/header.php, header-nav.php

const DESKTOP_QUERY = '(min-width: 900px)';

// Minimální odstup dropdownu od pravého okraje okna, než se otočí doleva.
const EDGE_GAP = 16;

// Šipka dolů u položek s podmenu (na mobilu je podmenu zabalené, tlačítko ho rozbalí).
const CHEVRON = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">'
  + '<path d="M3 6l5 5 5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

export default function initRedesignHeader() {
  const header = document.querySelector('[data-rd-header]');

  if (!header) {
    return;
  }

  const burger = header.querySelector('.rd-header__burger');
  const nav = header.querySelector('.rd-nav');
  const mq = window.matchMedia(DESKTOP_QUERY);
  const parents = nav ? Array.from(nav.querySelectorAll('.rd-nav__list > .menu-item-has-children')) : [];

  const isDesktop = () => mq.matches;

  // Výška hlavičky do CSS proměnné – pro scroll-margin kotev a sticky prvky pod hlavičkou.
  const updateHeight = () => {
    document.documentElement.style.setProperty('--rd-header-h', `${header.offsetHeight}px`);
  };

  // Desktop: dropdown se otevírá doprava, doleva jen když by vpravo vyjel z okna.
  const placeSub = (item) => {
    const sub = item.querySelector(':scope > .sub-menu');
    if (!sub) {
      return;
    }
    item.classList.remove('is-flipped');
    const overflows = sub.getBoundingClientRect().right > document.documentElement.clientWidth - EDGE_GAP;
    item.classList.toggle('is-flipped', overflows);
  };

  const setParentOpen = (item, open) => {
    item.classList.toggle('is-open', open);
    if (open && isDesktop()) {
      placeSub(item);
    }
    const link = item.querySelector(':scope > a');
    if (link) {
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    const toggle = item.querySelector(':scope > .rd-nav__toggle');
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', `${open ? 'Zabalit' : 'Rozbalit'} podmenu ${toggle.dataset.rdLabel}`);
    }
  };

  // Tlačítko se šipkou vedle odkazu – používá se na mobilu (na desktopu je schované CSS),
  // aby odkaz na rodičovskou stránku zůstal odkazem a podmenu se rozbalovalo zvlášť.
  const addToggle = (item) => {
    const link = item.querySelector(':scope > a');
    const sub = item.querySelector(':scope > .sub-menu');

    if (!link || !sub) {
      return;
    }

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'rd-nav__toggle';
    toggle.dataset.rdLabel = link.textContent.trim();
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', `Rozbalit podmenu ${toggle.dataset.rdLabel}`);
    toggle.innerHTML = CHEVRON;

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      const open = !item.classList.contains('is-open');
      if (open) {
        closeAll(item);
      }
      setParentOpen(item, open);
    });

    item.insertBefore(toggle, sub);
  };

  const closeAll = (except) => {
    parents.forEach((item) => {
      if (item !== except) {
        setParentOpen(item, false);
      }
    });
  };

  const setBurger = (open) => {
    if (!open) {
      closeAll();
    }
    header.classList.toggle('is-open', open);
    if (burger) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Zavřít menu' : 'Otevřít menu');
    }
    updateHeight();
  };

  if (burger) {
    burger.addEventListener('click', () => {
      setBurger(!header.classList.contains('is-open'));
    });
  }

  parents.forEach((item) => {
    const link = item.querySelector(':scope > a');

    if (!link) {
      return;
    }

    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');
    addToggle(item);

    item.addEventListener('mouseenter', () => {
      if (isDesktop()) {
        closeAll(item);
        setParentOpen(item, true);
      }
    });

    item.addEventListener('mouseleave', () => {
      if (isDesktop()) {
        setParentOpen(item, false);
      }
    });

    // Desktop: první klik/tap otevře dropdown, druhý následuje odkaz.
    // Mobil: odkaz vede rovnou na stránku, podmenu se rozbaluje tlačítkem se šipkou.
    link.addEventListener('click', (event) => {
      if (!isDesktop()) {
        return;
      }
      if (!item.classList.contains('is-open')) {
        event.preventDefault();
        closeAll(item);
        setParentOpen(item, true);
      }
    });

    // Klávesnice: když fokus opustí celou položku, dropdown se zavře.
    item.addEventListener('focusout', (event) => {
      if (isDesktop() && !item.contains(event.relatedTarget)) {
        setParentOpen(item, false);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) {
      closeAll();
      if (!isDesktop()) {
        setBurger(false);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
      setBurger(false);
    }
  });

  const onModeChange = () => {
    closeAll();
    setBurger(false);
  };

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onModeChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onModeChange);
  }

  window.addEventListener('resize', updateHeight);
  updateHeight();
}
